module.exports = __webpack_public_path__ + "assets/img/WeChat-icon.794bce65.png";